export const en = {
  common: {
    brand: "UN8",
    brandTag: "Exclusive Christian dating",
    continue: "Continue",
    next: "Next",
    leave: "Leave",
    leaveForNow: "Leave for now",
    yes: "Yes",
    no: "No",
    goBack: "Go back",
    saving: "Saving…",
    submitting: "Submitting…",
    pleaseWait: "Please wait…",
    ellipsis: "…",
    male: "Male",
    female: "Female",
    phases: {
      gate: "Gate",
      verify: "Verify",
      setup: "Setup",
      profile: "Profile",
    },
    storageQuota:
      "This phone is out of space for saved answers. Free some storage, then try again.",
    storageDisabled:
      "This browser will not save your answers. Turn off private mode, or allow site data, then reload.",
    charMeta: "{len}/{min} min · {current}/{max}",
    charMetaMin: "min {min} characters",
  },

  welcome: {
    promise: "Our goal is that you delete this app as quickly as possible.",
    sub:
      "Four people a week. Real faces. Courtship toward marriage — then delete the app.",
    signedInAs: "Signed in as {email}",
    liveServer: " · live server",
    deviceOnly: " · this device only",
    migrateOffer:
      "This device still has a local profile. Upload it to the shared server so other phones can see you after moderation? Nothing is uploaded until you choose.",
    uploadLocalProfile: "Upload my local profile",
    keepOnDevice: "Keep it on this device only",
    migrateNeedGender: "Choose Male or Female in your profile first.",
    migrateDone:
      "Profile text uploaded. Re-upload ID, video, and photos so moderation can review them.",
    deleteConfirm:
      "Permanently delete your account, all messages, and all media (including ID and video) from the server?",
    accountDeleted: "Account deleted.",
    begin: "I’m in",
    betaTitle: "Welcome UN8 Beta Tester!",
    betaBody:
      "This is the closed web test. Use the app in this browser. Play Billing and TestFlight are not open yet — there is no web checkout.",
    tryMatching: "Open matching",
    reportBug: "Report a bug",
    startFresh: "Start fresh",
    continueOnboarding: "Continue onboarding",
    logIn: "Log in",
    logOut: "Log out",
    reviewConsole: "Review console",
    matching: "Matching",
    deleteMyAccount: "Delete my account",
  },

  intro: {
    title: "Welcome to UN8",
    text: "Serious faith. Real faces. Courtship toward marriage — then delete the app.",
    videoHint: "Drop public/intro.mp4 to play a short brand video here.",
    continue: "I’m in",
    skip: "Skip",
    betaLine: "Welcome UN8 Beta Tester!",
  },

  faith: {
    eyebrow: "First.",
    title: "I follow Jesus Christ",
    text: "UN8 is for followers of Jesus Christ.",
    yesTitle: "Yes",
    yesBody: "",
    noTitle: "No",
    noBody: "",
    respectTitle: "With respect",
    respectBody:
      "UN8 is built for one community, and we would rather be honest than waste your time. Use Leave below, or Back, if this is not your home.",
    sharedTitle: "Shared foundation",
    sharedBody: "Faith is not a label here. It is the ground on which you meet.",
    hintNotChristian:
      "UN8 is for followers of Jesus Christ. Tap Leave below, or choose Yes if that is you.",
    hintUnset: "Tap Yes to continue, or Leave / Back if this is not your home.",
  },

  rules: {
    eyebrow: "Then this.",
    title: "Three rules. No exceptions.",
    text:
      "Affirm every rule. All three are required. Violations lead to permanent removal. Fake profiles are banned forever.",
    agreeContinue: "I agree — continue",
    respectful: {
      title: "Be respectful",
      description: "Speak and act with dignity. Every person here is made in God’s image.",
    },
    noSexualContent: {
      title: "No sexual content",
      description: "No explicit photos, messages, or requests. Purity is not optional here.",
    },
    noDominance: {
      title: "Do not dominate or control",
      description: "No coercion, manipulation, or pressure. Love does not control.",
    },
    hint: "Tick all three promises before you continue.",
  },

  intent: {
    eyebrow: "",
    title: "What are you looking for?",
    text: "",
    marriage: {
      label: "A life partner",
      description: "",
    },
    discernment: {
      label: "Marriage, in a year or two",
      description: "",
    },
    notCasual: {
      label: "Friendship first, then see",
      description: "",
    },
    hint: "Pick one.",
  },

  account: {
    eyebrow: "Account",
    title: "What’s your email?",
    text: "",
    recoveryTitle: "Save your recovery code",
    recoveryText:
      "Shown once. Without it, a lost passphrase cannot be reset in this closed test.",
    savedContinue: "I have saved it — continue",
    handle: "Email",
    handlePlaceholder: "you@example.com",
    passphrase: "Password",
    passphrasePlaceholder: "At least 8 characters",
    signedInTitle: "Signed in",
    signedInBody: "{email} · {userId}",
    trustTitle: "Trust standard",
    trustBody:
      "No profile is visible until identity verification is complete and moderation approves you.",
    continueToVerification: "Continue to verification",
    hintEmail: "Type an email address that includes @.",
    hintPassword: "Choose a password of at least 8 characters.",
  },

  verify: {
    intro: {
      eyebrow: "Verification",
      title: "Trust is the gate",
      text:
        "Upload a government ID, a confirmation video, and {min}–{max} real photos. Everything enters a review queue before your profile can appear.",
      whyTitle: "Why we verify",
      whyBody:
        "Catfishing and half-truths have no place here. Fake profiles are banned permanently. Media is stored with status pending_review until approved.",
      start: "Start verification",
    },
    steps: {
      id: {
        title: "Government ID",
        description: "Passport or national ID — camera or file upload.",
      },
      video: {
        title: "Confirmation video",
        description: "A short recording that proves you are present.",
      },
      photos: {
        title: "Real photos",
        description: "Four to six clear photos of yourself.",
      },
      review: {
        title: "Integrity review",
        description: "Uploads stay pending_review until staff confirm.",
      },
    },
    id: {
      eyebrow: "Step 1 of 4",
      title: "Government ID",
      text:
        "Capture or upload your passport or national ID. Nothing is posted publicly — status stays pending_review until staff confirm.",
      savedTitle: "ID saved",
      savedBody:
        "Next is a short confirmation video of your face, then {min}–{max} real photos of yourself. Continue unlocks when this ID shows saved.",
      hint: "Take or upload a photo of your government ID, then wait until it says saved.",
    },
    video: {
      eyebrow: "Step 2 of 4",
      title: "Confirmation video",
      text:
        "Record a short clip (about {seconds} seconds) or upload one. Face the camera. Speak clearly. This proves you are present — not a scraped gallery.",
      hint: "Record a short confirmation video, then wait until it says saved.",
    },
    photos: {
      eyebrow: "Step 3 of 4",
      title: "Your best photo.",
      text: "One is enough to start.",
      continueToReview: "Next",
      hint: "Add {min} to {max} clear photos of yourself. Continue unlocks when they are saved.",
    },
    review: {
      eyebrow: "Step 4 of 4",
      title: "Integrity review",
      text: "Media is queued as pending_review{underUser}. Matches and likes will use the same id.",
      underUser: " under user {userId}",
      governmentId: "Government ID",
      confirmationVideo: "Confirmation video",
      photos: "Photos",
      missing: "Missing",
      filesReady: "{count} files ready",
      submittedTitle: "Submitted for review",
      submittedText:
        "Application id equals auth user id so approve → pool and mutual likes stay aligned.",
      submitContinue: "Submit & continue",
    },
  },

  setup: {
    eyebrow: "Account setup",
    title: "A few prompts.",
    text: "Not a census. Say enough that someone real can find you.",
    beginSetup: "Let’s go",
    pillars: {
      faith: { name: "Faith", text: "Why you follow Christ." },
      character: {
        name: "Character",
        text: "Loyalty, honesty, passion, commitment — rated 1–10.",
      },
      story: { name: "Story", text: "Who you are and what you seek." },
      life: { name: "Life", text: "Hobbies, reading, and vocation." },
    },
    whyChristian: {
      eyebrow: "Faith",
      title: "Why Jesus?",
      text: "The real reason. Not the Sunday-school one.",
      label: "Your answer",
      placeholder: "The real reason. Not the Sunday-school one.",
      hint: "A sentence is enough.",
    },
  },

  scales: {
    eyebrow: "Character scales",
    title: "Let's Be honest!",
    text: "",
    loyalty: {
      label: "Loyalty",
      hint: "Be honest — how faithfully do you stand by those you love?",
    },
    honesty: {
      label: "Honesty",
      hint: "How consistently do you tell the full truth?",
    },
    passion: {
      label: "Passion",
      hint: "Conviction and depth — not performance.",
    },
    commitment: {
      label: "Commitment",
      hint: "How ready are you to build something that lasts?",
    },
    social: {
      label: "Social",
      hint: "Quiet evenings at one end. A full room at the other.",
    },
    creativity: {
      label: "Creativity",
      hint: "How freely do you make and invent?",
    },
    humor: {
      label: "Humor",
      hint: "How readily do you laugh — and make others laugh?",
    },
    hint: "Set Loyalty, Honesty, Passion, and Commitment.",
  },

  about: {
    eyebrow: "About you",
    title: "Who are you, really?",
    text: "",
    label: "About you",
    placeholder: "A few sentences. The ones you’d tell a friend.",
    hint: "A sentence is enough.",
  },

  looking: {
    eyebrow: "Partner",
    title: "What are you looking for?",
    text: "",
    partnerCountry: "Preferred country for a partner",
    partnerCountryHint:
      "Choosing “same as mine” or a specific country hides candidates from other countries. Missing country on their profile never blocks (incomplete, not a mismatch).",
    partnerCountrySame: "Same country as me",
    partnerCountrySameBody: "Only show people in my country.",
    partnerCountryAny: "Any country",
    partnerCountryAnyBody: "No country filter — affinity decides.",
    partnerCountrySpecific: "A specific country",
    partnerCountrySpecificBody: "Only show people from the country I pick.",
    partnerCountryPick: "Country",
    label: "Desired character traits",
    placeholder: "Character. Not a shopping list.",
    hint: "A sentence is enough.",
  },

  loveReady: {
    eyebrow: "Threshold",
    title: "Ready to meet the love of your life?",
    text: "",
    yesTitle: "Yes",
    yesBody: "",
    noTitle: "Not yet",
    noBody: "",
    comeBackTitle: "Come back when ready",
    comeBackBody:
      "UN8 is for people prepared to meet — not to collect options. Use Leave below if you want to stop for now. Your answers are saved on this phone.",
    hintNo:
      "Only “Yes” continues. If you are not ready, tap Leave for now — your answers stay on this phone.",
    hintUnset: "Tap Yes if you are ready to meet someone for marriage.",
  },

  lifestyle: {
    eyebrow: "Lifestyle",
    title: "What do you actually do?",
    text: "Fun, then work. That’s it.",
    anythingInteresting: "Anything else interesting?",
    anythingInterestingPlaceholder:
      "Optional — quirks, habits, or life details that help someone know you.",
    anythingInterestingHint: "Optional. Shown with your about text.",
    hobbies: "Current sports or hobbies",
    hobbiesPlaceholder: "What you do for fun.",
    reading: "Do you read?",
    readingHint: "1 = almost never · 10 = daily, deep reading",
    profession: "Profession / sector",
    professionPlaceholder: "What you do for work.",
    hintHobbies: "Name one thing you actually do.",
    hintReading: "Slide “Do you read?” so a number from 1 to 10 shows.",
    hintProfession: "A short word is enough.",
  },

  faithDepth: {
    eyebrow: "Matching · Faith",
    title: "How central is your faith?",
    text:
      "Serving God — how important in your life? Answer honestly. Matching uses this for depth, not performance.",
    serving: "Serving God — importance",
    servingHint: "10% … 100%. Slide in steps of 10.",
    keepsCommandments: "Do you keep the commandments?",
    grewUpInChurch: "Did you grow up in church?",
    churchAttendance: "Church attendance",
    frequent: { label: "Frequent", hint: "Regular gathering with the body of Christ." },
    seldom: { label: "Seldom", hint: "Occasionally, not a weekly rhythm." },
    never: { label: "Never", hint: "Not currently attending." },
    spreadsGospel: "Do you spread the gospel?",
    hasIdols: "Do you have idols?",
    hintServing: "Slide how important serving God is in your life.",
    hintCommandments: "Answer whether you keep the commandments — Yes or No.",
    hintGrewUp: "Answer whether you grew up in church — Yes or No.",
    hintAttendance: "Choose how often you attend church.",
    hintGospel: "Answer whether you share the gospel — Yes or No.",
    hintIdols: "Answer whether you have idols — Yes or No.",
  },

  character: {
    eyebrow: "Matching · Character",
    title: "Who you are at home",
    text:
      "Character for courtship — peacemaking, manners, honesty. Inflating answers only mismatches you later.",
    peacemaker: "Are you a peacemaker?",
    homebuilder: "Are you a homebuilder?",
    humorous: "Are you humorous?",
    caring: "Caring and affectionate?",
    peacefulHome: "Do you want a peaceful home — free of fighting?",
    manners: "Good manners?",
    honestyRating: "Honesty rating on this questionnaire",
    honestyHint: "1–10 — how honestly are you answering?",
    hintPeacemaker: "Answer each Yes or No, starting with peacemaker.",
    hintHomebuilder: "Answer whether you are a homebuilder.",
    hintHumorous: "Answer whether you are humorous.",
    hintCaring: "Answer whether you are caring and affectionate.",
    hintPeaceful: "Answer whether you want a peaceful home.",
    hintManners: "Answer whether you have good manners.",
    hintHonesty: "Slide your honesty rating from 1 to 10.",
  },

  history: {
    eyebrow: "Matching · History",
    title: "Past and readiness",
    text:
      "Substances, childhood, scars, and whether you are ready for a lasting relationship. Truth here protects both of you.",
    marijuana: "Have you used marijuana?",
    lsd: "Have you used LSD?",
    otherDrugs: "Have you used other drugs?",
    addicted: "Have you been addicted?",
    childhood: "Stable, loving childhood?",
    scars: "Any scars / damaged?",
    lasting: "Ready for a lasting relationship?",
    hintStart: "Answer every Yes or No on this page, starting at the top.",
    hintLsd: "Answer the LSD question — Yes or No.",
    hintOtherDrugs: "Answer whether you have used other drugs.",
    hintAddicted: "Answer whether you have been addicted.",
    hintChildhood: "Answer whether your childhood was stable and loving.",
    hintScars: "Answer whether you carry scars.",
    hintLasting: "Answer whether you are ready for a lasting relationship.",
  },

  appearance: {
    eyebrow: "Matching · Appearance",
    title: "Tattoos",
    text: "Your tattoos, and whether tattoos on a partner are acceptable to you.",
    hasTattoos: "Do you have tattoos?",
    acceptsPartner: "Accept tattoos on a partner?",
    hintHas: "Say whether you have tattoos — Yes or No.",
    hintAccepts: "Say whether tattoos on a partner are acceptable to you.",
  },

  home: {
    eyebrow: "Matching · Home & land",
    title: "Land, skills, self-sufficiency",
    text:
      "Herbs, growing food, fruit forest, prepping, community farming, preserving, survival — and any special skills.",
    herbKnowledge: "Herb knowledge?",
    plantOwn: "Do you plant your own fruit and vegetables?",
    fruitForest: "Interested in a fruit forest?",
    prepping: "Prepping for calamities?",
    communityFarming: "Community farming / independent living?",
    canning: "Canning and preserving?",
    survival: "Survival skills?",
    specialSkills: "Special skills (optional)",
    specialPlaceholder: "Anything else you bring to a household or land…",
    hintStart: "Answer every Yes or No on land and skills, starting at the top.",
    hintPlant: "Answer whether you plant your own fruit and vegetables.",
    hintFruitForest: "Answer whether a fruit forest interests you.",
    hintPrepping: "Answer whether you prep for calamities.",
    hintCommunity: "Answer whether community farming interests you.",
    hintCanning: "Answer whether you can and preserve food.",
    hintSurvival: "Answer whether you have survival skills.",
  },

  family: {
    eyebrow: "Matching · Family",
    title: "Children, faith depth, substances",
    text: "What you need in a partner on faith intensity, children, and past substance use.",
    children: "Children",
    wants: { label: "Wants children", hint: "Building a family is part of the vision." },
    doesNotWant: { label: "Does not want children", hint: "Clear no on children." },
    open: { label: "Open", hint: "Discerning — not locked either way." },
    hasLivingWith: {
      label: "Has children — living with them",
      hint: "Children are already part of daily life.",
    },
    requiredFaith: "Minimum faith level you need in a partner",
    requiredFaithHint: "10% … 100%. Hard gate when both sides have answered.",
    acceptsSubstances: "Accept past substance use in a partner?",
    hintChildren: "Choose one card about children.",
    hintFaith: "Slide the minimum faith level you hope for in a partner.",
    hintSubstances: "Say whether past substance use in a partner is acceptable.",
  },

  ancestry: {
    eyebrow: "Matching · Background",
    title: "Background preferences",
    text:
      "Share your background and what you are open to in a partner. This only shapes ranking — it never hides someone from the deck.",
    yourBackground: "Your background (select all that apply)",
    openToPartner: "Open to in a partner",
    codeDesc: "Code: {code}",
    anyDesc: "Strongest preference for breadth — recommended when unsure.",
    preferenceOnly: "Preference only — not a gate.",
    hintOwn:
      "Tick at least one background that describes you. This only helps ranking — it never hides anyone.",
    hintAccepted: "Tick what you are open to in a partner, or “Open — no preference”.",
  },

  interests: {
    eyebrow: "Matching · Interests",
    title: "What you enjoy",
    text: "Pick at least one. Overlap helps ranking; silence is never punished.",
    hint: "Tick at least one interest.",
  },

  reflection: {
    eyebrow: "Matching · Reflection",
    title: "In your own words",
    text: "These four answers are shown in full and never scored. Write what is true.",
    textThree: "These three answers are shown in full and never scored. Write what is true.",
    describeYourself: "Describe yourself",
    lifePurpose: "Life purpose",
    fifteenYear: "You and the love of your life in 15 years",
    weaknesses: "Weaknesses",
    hintDescribe: "Describe yourself in at least {min} characters.",
    hintPurpose: "Write your life purpose in at least {min} characters.",
    hintVision: "Write the 15-year vision in at least {min} characters.",
    hintWeaknesses: "Name a weakness in at least {min} characters.",
  },

  profile: {
    eyebrow: "Profile",
    title: "What is your Info?",
    text: "Your real name. UN8 only has verified people.",
    firstName: "First name",
    firstNamePlaceholder: "Your real name",
    age: "Age",
    agePlaceholder: "18+",
    country: "Country",
    countryPlaceholder: "Select your country",
    geoDetected: "Detected from your connection: {country}. You can change it.",
    geoUnavailable: "Could not detect country — please choose yours.",
    city: "City",
    cityPlaceholder: "Where you are based",
    sex: "Sex",
    maleBody: "I am a man.",
    femaleBody: "I am a woman.",
    hintName: "Type your first name (at least two letters).",
    hintAge: "Age must be 18 or older.",
    hintCity: "Type the city where you live.",
    hintGender: "Choose Male or Female so matching can work.",
  },

  ready: {
    title: "You’re in.",
    textNamed: "{name}, go find them — then delete the app.",
    text: "Go find them — then delete the app.",
    summaryAria: "Setup summary",
    christianRules: "Christian · rules affirmed",
    mediaLine: "ID · video · {photoCount} photos · queue {pending}",
    scalesLine: "Scales L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    genderProfession: "{gender} · {profession}",
    sexUnset: "Sex —",
    professionFallback: "profession",
    userLine: "User {userId}",
    enterMatching: "See your four",
    needGender: "Go back to the profile step and choose Male or Female, then try again.",
  },

  match: {
    brandTag: "Matching",
    navOnboarding: "Onboarding",
    navReview: "Review",
    navMatching: "Matching",
    navSelection: "Weekly selection",
    navWhoLiked: "Has liked you",
    navMessages: "Messages",
    navProfile: "Profile",
    logOut: "Log out",
    enterTitle: "Enter matching",
    enterText:
      "Log in with the same email from onboarding. Application, pool, likes, and matches all use your stable user id.",
    email: "Email",
    emailPlaceholder: "you@example.com",
    password: "Password",
    passwordPlaceholder: "Your password",
    logIn: "Log in",
    quietSignIn: "Sign in",
    guestOr: "Or try the demo deck (opposite-sex four · no extra gender step)",
    guestDemo: "Continue demo",
    guestMan: "Guest as man",
    guestWoman: "Guest as woman",
    needGender:
      "Choose Male or Female in onboarding (Profile step) first — matching uses that for opposite-sex pairing.",
    goOnboarding: "Go to onboarding →",
    guestSession: "Demo session · demo pool",
    bootDemo: "Opening your weekly four…",
    signInHint: "Already a member?",
    closeSignIn: "Close",
    man: "man",
    woman: "woman",
    tabToday: "Weekly selection",
    tabMatches: "Messages ({count})",
    weeklyTitle: "Your 4 for this week",
    weeklyTitleCount: "Your {count} for this week",
    weeklyCountdown: "Next selection in {days} days",
    weeklyCountdownOne: "Next selection in 1 day",
    weeklyCountdownSoon: "Next selection soon",
    shortWeekCopy:
      "This week there are {count}. We never suggest someone who is not a fit.",
    shortWeekTwo:
      "This week there are two. We never suggest someone who is not a fit.",
    weekDone: "That’s this week’s selection",
    weekDoneText:
      "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    extraReveal: "Reveal one more",
    extraRevealLeft: "{count} extra reveal(s) left",
    whoLikedTitle: "See who liked you",
    whoLikedHint:
      "Like them back and you match. Then chat is more than thirty-three letters.",
    whoLikedLocked:
      "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    whoLikedEmpty: "No one new has liked you yet.",
    inboundTitle: "Liked you",
    likeBack: "Like back",
    likeHeart: "Give like",
    flame: "Give flame",
    flameNoneLeft: "No flame left this week. It comes back Monday.",
    flameLead: "Give {name} a flame.",
    flameOnly: "Flame only",
    flameSend: "Send flame",
    heartBurstTitle: "Like to {name}",
    flameBurstTitle: "Flame to {name}",
    flameSent: "You sent {name} a flame.",
    flipNeedsLike: "Give a like to turn the card.",
    likedStays: "A like stays. You cannot take it back.",
    composeCancel: "Cancel",
    hudAria: "Credits, hearts, and flame",
    menuOpen: "Open menu",
    menuClose: "Close",
    refreshTitle: "Find Love",

    /* ── Weekly heart budget + the 20-letter note (Masco 2026-09-13) ── */
    heartsNoneLeft:
      "No hearts left this week. Your hearts come back Monday.",
    commentLead: "Give {name} a like.",
    commentPlaceholder: "33 letters, no more",
    commentCount: "{count} / {max}",
    commentSend: "Send like",
    heartOnly: "Heart only",
    commentTooLong: "That is over {max} letters. The heart went; the note did not.",
    commentAnchors: {
      about: "About",
      lookingFor: "Looking for",
      hobbies: "Interests",
      photo: "Photo",
    },
    profileTitle: "Your profile",
    profileSub: "Account, subscription, and tester tools.",
    verify: {
      brandTag: "Verify",
      title: "Verify to message",
      sub:
        "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      cta: "Add ID and video",
      videoCta: "Add a confirmation video",
      submitted: "ID and video are in. You can message while we review.",
      done: "You’re verified.",
      back: "Back",
      continue: "Continue",
      idEyebrow: "Identity",
      videoEyebrow: "Presence",
      idText:
        "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      videoText:
        "A short clip (about {seconds} seconds). Face the camera. This proves you are present.",
    },
    yourMatches: "Your messages",
    matchesSub:
      "Persistent mutual interest · {count} outbound {likesWord}",
    like: "like",
    likes: "likes",
    emptyMatches: "No mutual interest yet. Keep discerning this week’s selection.",
    valuesScore: "Values {score}",
    chatOpen: " · Chat open",
    tapToChat: " · Tap to chat",
    personLine: "{name}, {age}",
    cityValues: "{city} · Values {score}",
    noProfileYet: "No profile yet",
    noProfileText:
      "Finish onboarding, or open Profile, then Begin. Guest matching is on the enter screen if you only want to look.",
    matchingPaused: "Matching paused",
    waitingModeration:
      "Your profile is waiting for moderation approval before the deck opens.",
    completeProfileFirst: "Complete and submit your profile first.",
    moderationDemoNote:
      "Showing demo people so you can try matching while you wait.",
    noOneYet: "No one to show yet",
    todaysSetDone: "That’s this week’s selection",
    emptyNeverHad:
      "There is nobody in this week’s list yet. We are still filling the pool — open Selection again in a moment, or come back when more members are approved.",
    emptyDone:
      "You have gone through this week’s selection. Come back when the next drop opens, or reset the deck to look again.",
    likesMayNotStick: " Likes may not stick.",
    poolMeta: "Pool: {pool} · Matches: {matches} · Liked: {liked}",
    demoPool: "demo",
    livePool: "{source} ({count})",
    resetDeck: "Reset deck",
    swapFour: "Find Love · 10 000 credits",
    memberNew: "Just joined",
    memberDays: "{days}d here",
    memberWeeks: "{weeks}w here",
    memberMonths: "{months}mo here",
    cardStatLoyalty: "LOY",
    cardStatHonesty: "HON",
    cardStatPassion: "PAS",
    cardStatCommit: "COM",
    cardStatSocial: "SOC",
    cardStatFaith: "FAI",
    cardStatCharacter: "CHA",
    cardStatPurpose: "PUR",
    cardStatHome: "HOM",
    cardStatAncestry: "ANC",
    cardStatTemper: "TEM",
    goToProfile: "Go to profile",
    goToProfileChat: "Profile & chat",
    holdToPeek: "Hold {name}’s card to see stats",
    holdOrOpenProfile: "Hold for stats, tap for {name}’s profile",
    likeToOpenProfile: "Like to open their full profile",
    waitLikeBack: "Waiting for {name} to like you back — then chat unlocks.",
    flipToStats: "Show {name}’s stats",
    flipToPhoto: "Show {name}’s photo",
    likeToFlip: "Hold to see stats. Like to open their profile.",
    swapNoCredits:
      "Not enough credits to refresh. Free switch and each Subscriber refresh cost 10 000.",
    likeSent: "Liked {name}. We’ll let them know — if they like you back, you match.",
    packTitle: "Your four",
    packSkip: "Tap to continue",
    newSelection: "Find Love",
    backToFour: "← Back to your four",
    backOnboarding: "Back to onboarding",
    feedEyebrowDemo: "Weekly selection · Demo pool",
    feedEyebrowLive: "Weekly selection · Pool ({source}, {count})",
    feedTitle: "Discern with care",
    left: "{count} left",
    pass: "Pass",
    interested: "♥ Like",
    swipeHint:
      "Pass is replaced within 24 hours when someone else fits. We never pad with a poor match.",
    celebrationEyebrow: "Mutual interest",
    celebrationTitle: "It’s a match",
    celebrationText: "{self} · {other}",
    celebrationWhyLabel: "Why you matched",
    celebrationNote: "",
    celebrationFusing: "Becoming one path…",
    celebrationReady: "",
    openChat: "Open chat",
    keepDiscerning: "Keep discerning",
    cardSeeking: "Seeking",
    cardHobbies: "Hobbies",
    matchingScore: "Matching score",
    affinity: "Matching score",
    valuesScoreLabel: "Matching score",
    scoreStrong: "Strong alignment",
    scoreSolid: "Solid alignment",
    scoreModerate: "Moderate alignment",
    scoreDifferent: "Different rhythms",
    characterAxisFoot: "Character axis includes the four pillars",
    youThem: "You {self} · Them {other}",
    stampInterest: "Interest",
    stampPass: "Pass",
    explainLikedYou: "They already liked you — this is mutual interest waiting to happen.",
    explainLegacyClose: "Your values scores sit close together ({score} of 100).",
    explainLegacyFuller:
      "A fuller “why” appears after both of you finish the matching questions.",
    explainFaith:
      "Your faith intensity is close — you take following Jesus with similar seriousness.",
    explainCharacter:
      "How you treat people at home lines up — peace, manners, and care.",
    explainPurpose:
      "You rated your own honesty similarly, which is a sign of shared seriousness.",
    explainHome:
      "You share an interest in land, growing food, or a self-sufficient home.",
    explainAncestry:
      "You both prefer similar family backgrounds. That is a preference, not a filter — nobody is hidden for it.",
    explainTemperament: "Your interests and temperament overlap.",
    explainFallback: "There is a possible match on the answers you both filled in.",
    explainOverall: "Matching score {score}/100",
    scoreBadge: "Matching score {score}/100",
    overlapAgree: "We agree on",
    overlapDisagree: "We see differently on",
    overlapItems: {
      keepsCommandments: "Following God's commandments",
      spreadsGospel: "Sharing the gospel",
      grewUpInChurch: "Growing up in church",
      peacemaker: "Being peacemakers at home",
      homebuilder: "Building a peaceful home",
      caringAffectionate: "Showing care and affection",
      wantsPeacefulHome: "Wanting a peaceful household",
      goodManners: "Good manners and respect",
      humorous: "Humour in daily life",
      herbKnowledge: "Knowing herbs and natural remedies",
      plantsOwnFruitVeg: "Growing your own food",
      interestedInFruitForest: "Food forests and land",
      preppingForCalamities: "Preparing for hard times",
      communityFarming: "Community farming and self-sufficiency",
      canningAndPreserving: "Canning and preserving food",
      survivalSkills: "Practical survival skills",
      readyForRelationship: "Readiness for a lasting relationship",
      stableChildhood: "A stable, loving childhood",
      sharedInterests: "{count} shared interests",
      faithIntensity: "Similar seriousness about faith",
    },
    affinityAxes: {
      faith: "Faith intensity",
      character: "Character & conduct",
      purpose: "Life purpose alignment",
      home: "Home & self-sufficiency",
      ancestry: "Cultural & background affinity",
      temperament: "Temperament fit",
    },
    scaleAxes: {
      loyalty: "Loyalty",
      honesty: "Honesty",
      passion: "Passion",
      commitment: "Commitment",
    },
  },

  chat: {
    brandTag: "Chat",
    unavailableTitle: "Chat unavailable",
    unavailableText: "This match is missing or does not belong to your session.",
    backToMatches: "Back to matches",
    backMatches: "← Matches",
    valuesSubscriber: "Values {score} · Subscriber",
    valuesTrial: "Values {score} · Trial",
    valuesKept: "Values {score} · Match kept",
    empty:
      "Say hello with care. On the shared backend, messages sync to both phones after a mutual match.",
    placeholder: "Message {name}…",
    ariaMessage: "Message",
    send: "Send",
  },

  billing: {
    paywallCopy:
      "Free: 4 people a week (10 000 credits to switch). Subscriber $4.99: 5 refreshes a week · VIP $9.99: unlimited. One new conversation start per week. Matches you already have stay free forever. Billing is Google Play only.",
    signInToMatch: "Sign in to use matching.",
    signInFirst: "Sign in first.",
    subscriberUntil: "Subscriber · until {date}",
    vipUntil: "VIP club · until {date}",
    freePlan: "Free · weekly four + credits",
    renewal: "renewal",
    freeTrial: "Free trial · {days} days (ends {date})",
    soon: "soon",
    trialEnded: "Trial ended · weekly four + matches & chat stay",
    freeTrialEnded: "Trial ended · weekly four + matches & chat stay",
    creditsBalance: "{count} credits",
    creditsUnlimited: "Unlimited credits",
    switchHint: " · weekly switch {cost}",
    subscribe: "Subscribe · ${price}/mo",
    subscribeEarly: "Subscribe early · ${price}/mo",
    activeNote: "Subscription active — who liked you and extra reveals are unlocked.",
    playOnly:
      "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    playOnlyShort: "Billing via Google Play only — no web payment.",
    playSubscribeMember: "Subscribe · Member $4.99/mo (Google Play)",
    playSubscribeVip: "Join VIP · $9.99/mo (Google Play)",
    playRestore: "Restore Google Play purchases",
    playUnavailable:
      "Google Play Billing opens inside the installed app (TWA). There is no web checkout.",
    playBusy: "Opening Google Play…",
    playError: "Could not complete Play purchase. Try again from the app.",
    activateSubscriberQa: "QA: activate Subscriber (local)",
    activateVipQa: "QA: activate VIP (local)",
    enablePush: "Notify me of likes & matches",
    pushEnabled: "Notifications on for likes & matches",
    pushBlocked: "Notifications blocked in browser settings",
    pushUnavailable: "Push needs VAPID keys from Masco — in-app likes still work.",
  },

  auth: {
    recoveryTitle: "Save your recovery code",
    recoveryText:
      "Write this down now. It is shown once. If you lose your passphrase, this code is the only way to reset it in the closed test.",
    savedContinue: "I have saved it — continue",
    welcomeBack: "Welcome back",
    createAccount: "Create your account",
    intro:
      "Handle and passphrase. No email or SMS is sent. Your id stays stable across onboarding, review, and matching.",
    tabLogin: "Log in",
    tabRegister: "Register",
    handle: "Handle",
    handlePlaceholder: "you@example.com or a short handle",
    passphrase: "Passphrase",
    passphrasePlaceholder: "At least 8 characters",
    submitLogin: "Log in",
    submitRegister: "Create account",
    backWelcome: "Back to welcome",
  },

  options: {
    origin: {
      african: "African",
      european: "European",
      asian: "Asian",
      latino: "Latino / Hispanic",
      middleEastern: "Middle Eastern",
      indigenous: "Indigenous",
      mixed: "Mixed",
      other: "Other",
      dutch: "Dutch",
      german: "German",
      any: "Open — no preference",
    },
    interest: {
      prayer: "Prayer",
      worship: "Worship",
      reading: "Reading",
      hiking: "Hiking",
      music: "Music",
      cooking: "Cooking",
      farming: "Farming / gardening",
      sports: "Sports",
      missions: "Missions",
      family: "Family life",
      crafts: "Crafts",
      outdoors: "Outdoors",
    },
  },

  capture: {
    yesNoDefaults: { yes: "Yes", no: "No" },
    id: {
      titleEmpty: "Government ID",
      titleReady: "ID ready",
      hintEmpty:
        "Passport or national ID. Take a live photo, or choose an image/PDF. All four corners visible.",
      hintReady: "{fileName} · {bytes}{saved}",
      savedSuffix: " · saved",
      previewAlt: "Government ID preview",
      pdfAria: "PDF document selected",
      takePhoto: "Take photo",
      retake: "Retake",
      chooseFile: "Choose file",
      replaceFile: "Replace file",
      remove: "Remove",
      uploading: "Uploading…",
      cameraTitle: "Photograph your ID",
      signIn: "Sign in before uploading ID.",
      uploadFailed: "Upload failed. Try again.",
      badFile: "Could not use this file.",
    },
    video: {
      titleEmpty: "Confirmation video",
      titleLive: "Camera live",
      titleReady: "Video ready",
      hintEmpty:
        "Say your first name and that you join UN8 honestly. 5–15 seconds.",
      hintReady: "{fileName} · {bytes}{saved}",
      rec: "REC {seconds}s",
      record: "Record",
      cameraUpload: "Camera upload",
      chooseFile: "Choose file",
      startRecording: "Start recording",
      cancel: "Cancel",
      stopSave: "Stop & save",
      recordAgain: "Record again",
      replaceFile: "Replace file",
      remove: "Remove",
      unsupported:
        "Live recording is unavailable here. Use camera upload or choose a file.",
      permissionDenied:
        "Camera permission denied. You can still upload a short video file.",
      signIn: "Sign in before uploading video.",
      uploadFailed: "Upload failed. Try again.",
      saveFailed: "Could not save recording.",
      badVideo: "Could not use this video.",
    },
    photos: {
      count: "{count} / {max} photos",
      minimumMet: "Minimum met",
      moreRequired: "{n} more required",
      listAria: "Verification photos",
      photoAlt: "Photo {n}",
      removeAria: "Remove photo {n}",
      camera: "Camera",
      takePhoto: "Take photo",
      chooseFiles: "Choose files",
      uploading: "Uploading…",
      hint:
        "Take photo opens the live camera. Choose files is only for gallery picks. Clear face shots — no filters that hide identity. Max {max}.",
      cameraTitle: "Take a photo of yourself",
      signIn: "Sign in before uploading photos.",
      someFailed: "Some photos failed to upload. Retry the failed ones.",
      addFailed: "Could not add photos.",
    },
    liveStill: {
      titleDefault: "Camera",
      close: "Close",
      capture: "Capture",
      cancel: "Cancel",
      hint: "Hold steady. The live camera stays open until you capture.",
      unavailable: "Camera is not available in this browser. Use Choose file instead.",
      permissionDenied: "Camera permission denied or unavailable. Use Choose file instead.",
      frameFailed: "Could not capture this frame.",
      saveFailed: "Could not save the photo.",
    },
    uploadStatus: {
      uploading: "uploading…",
      failed: "upload failed",
      savedLocally: "saved locally",
      uploaded: "uploaded",
      stored: "stored",
      awaitingUpload: "Awaiting upload",
      localFallbackNote:
        "{error} File is saved on this device; retry when the sign endpoint is up.",
    },
  },
  language: {
    label: "Language",
    choose: "Choose language",
  },
  shell: {
    back: "Back",
    goBackAria: "Go back",
  },
  voiceAssistant: {
    title: "UN8 voice guide",
    fabAria: "Open voice assistant",
    panelAria: "Voice assistant controls",
    start: "Start",
    startAria: "Start voice conversation",
    starting: "Starting…",
    stop: "Stop",
    stopAria: "Stop voice conversation",
    close: "Close",
    closeAria: "Close voice assistant panel",
    mute: "Mute",
    muteAria: "Mute assistant audio",
    unmute: "Unmute",
    unmuteAria: "Unmute assistant audio",
    statusIdle: "Tap Start to talk with the UN8 guide.",
    statusConnecting: "Connecting…",
    statusListening: "Listening — speak when ready.",
    statusSpeaking: "Speaking…",
    statusError: "Connection error.",
    unavailableNotConfigured: "Voice assistant unavailable — not configured.",
    micDenied: "Microphone permission denied. Allow the mic in browser settings, then try again.",
    errorGeneric: "Voice assistant could not connect. Try again in a moment.",
  },

  questionnaire: {
    /** Skip button label on optional cards */
    skipForNow: "Skip for now",
    /** Quiet line shown below the skip button */
    skipConsequence: "Answered profiles are shown first.",
    /** Continue button on multi-select screens (ancestry, interests) */
    confirm: "Continue",
    /** Shown at top of all questionnaire sections */
    progressLabel: "{current} of {total}",
    /** Free-text soft-target guidance */
    fewSentences: "A few sentences",
    /** Ancestry preference disclaimer shown on that card */
    ancestryNote:
      "This is a preference and shapes ranking only — it never hides someone from the deck.",
  },
} as const;
